module.exports = __webpack_public_path__ + "static/media/2.3d4ac1b2.jpg";